<script>
import LazyImage from "@/components/atoms/lazy-image";
import Paginator from "@/components/molecules/pagination/paginator";
import ReviewAverageBarList from "@/components/molecules/review-average-bar-list";
import DividerHeading from "@/components/molecules/divider-heading";
import RateStar from "@/components/atoms/rate-star/index";
import ReviewList from "@/containers/product-sheet/review-list";
import ButtonIcon from "@/components/molecules/button-icon";
import ReviewSort from "@/components/molecules/review-sort";

import avisVerifiesCodes from "@/utils/avis-verifies-codes";

export default {
  name: "ProductReviewDetails",
  components: {
    LazyImage,
    DividerHeading,
    Paginator,
    ReviewAverageBarList,
    RateStar,
    ReviewList,
    ButtonIcon,
    ReviewSort
  },
  emits: ["filterReviews", "showMore"],
  data() {
    return {
      avisVerifiesCodes
    };
  },
  props: {
    rateAverage: {
      type: Number,
      required: true
    },
    reviewsList: {
      type: Array,
      required: true
    },
    statistics: {
      type: Object,
      required: true
    },
    navigation: {
      type: Object,
      required: true
    },
    sortMethods: {
      type: Array,
      required: true
    }
  },
  methods: {
    selected(e, param) {
      this.$emit("filterReviews", e, param);
    },
    showMore() {
      this.$emit("showMore");
    }
  }
};
</script>
<template>
  <div
    v-if="reviewsList.length> 0"
    class="c-product-review-details"
  >
    <DividerHeading dotted>
      <h2 class="c-product-review-details__title">
        Avis clients
      </h2>
    </DividerHeading>
    <div class="c-product-review-details__content">
      <div class="c-product-review-details__aside">
        <p class="c-product-review-details__average-score-wrapper">
          <span class="c-product-review-details__average-score">
            {{ String(rateAverage).replace(".", ",") }}
          </span>
          / 5
        </p>
        <RateStar
          id="total-rate"
          variant="average-rate"
          :score="rateAverage"
          :max="5"
          icon-size="md"
          class="c-product-review-details__average-rate u-mt-sm"
        />
        <p class="c-product-review-details__review-total">
          sur {{ statistics.total }} avis
        </p>
        <p
          v-if="statistics.positive_recommendations_total > 0"
          class="u-color-text-light u-font-14 u-mt-xs"
        >
          {{ statistics.positive_recommendations_total }} {{ statistics.positive_recommendations_total > 1 ? "recommandent" : "recommande" }} ce produit
        </p>
        <ReviewAverageBarList
          :total-rate="statistics.total"
          :count-by-rate="statistics.counts_by_rate"
          class="c-product-review-details__average-bar-list u-mt-lg"
        />
      </div>
      <div class="u-flex-item-fluid">
        <ReviewSort
          :sort-methods="sortMethods"
          :total-reviews="navigation.nb_total_items"
          class="u-mb-lg"
          @sort="(e) => selected(e, 'sortBy')"
        />
        <ReviewList :reviews="reviewsList" />
        <div class="u-flex u-flex-align-center u-flex-column u-mt-md">
          <ButtonIcon
            v-if="navigation.current_page < navigation.total_pages"
            icon-name="arrow-down"
            icon-position="right"
            variant="primary"
            icon-color="primary"
            icon-size="sm"
            radius="full"
            size="md"
            outline
            class="u-mb-sm"
            @click="showMore"
          >
            Voir plus d'avis
          </ButtonIcon>
          <Paginator
            v-if="navigation.total_pages > 1"
            :current="navigation.current_page"
            :total="navigation.total_pages"
            @navigate="(e) => selected(e, 'pageIndex')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/product-reviews-details.scss";
</style>
